// extracted by mini-css-extract-plugin
export default {"back-link":"styles_back-link__EWxEJ","back-link__icon":"styles_back-link__icon__a1n9I"};